<i18n src="./resources/locales.json" />

<template>
  <section class="animation-container">
    <div class="avatar-container">
      <EcsAvatar
        v-if="participants.length === 1"
        :contact-id="participants[0].id"
        :alt="participants[0].name"
        :size="32"
        no-animation
      />
      <v-avatar v-else :size="32" color="var(--v-secondary-base)">
        <v-icon>mdi-account-group</v-icon>
      </v-avatar>
    </div>
    <div class="content">
      <EcsTypingAnimation class="typing-animation" />
      <div class="typing-text">{{ names }}</div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsAvatar from '@/components/ecs-base-interaction-components/ecs-avatar/EcsAvatar';
import EcsTypingAnimation from '@/components/ecs-typing-animation/EcsTypingAnimation';

export default {
  name: 'EcsTypingAnimationAsMessage',

  components: {
    EcsAvatar,
    EcsTypingAnimation
  },

  props: {
    typingParticipants: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters('CONTACTS', ['getContact']),

    participants() {
      return this.typingParticipants.map(participant => this.getContact(participant.id) || participant);
    },

    names() {
      const nameList = this.participants.map(participant => participant.name.split(' ')[0]);
      if (this.typingParticipants.length === 1) {
        return this.$t('isTyping', { name: nameList[0] });
      } else {
        const commaSeparatedNames = nameList.slice(0, nameList.length - 1).join(', ');
        const lastPersonName = nameList[nameList.length - 1];
        return this.$t('areTyping', { commaSeparatedNames, lastPersonName });
      }
    }
  }
};
</script>

<style src="./scoped.css" scoped />
